




import * as am4core from "@amcharts/amcharts4/core";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Optional } from "@amcharts/amcharts4/core";
import { XYChart } from "@amcharts/amcharts4/charts";
import { XYChartPayload } from "@/models/XYChartPayload";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import xyChart from "@/services/charts/XYChart";

am4core.useTheme(am4themes_animated);

@Component({
  name: "AMBarChart"
})
export default class AMBarChart extends Vue {
  // ===== Props ===== //
  @Prop(Array) private readonly items!: [];
  // ===== Data ===== //
  private chart: XYChart | null = null;
  // ===== Computed ===== //
  get renderColor(): string {
    return this.$vuetify.theme.dark ? "#F1F1F1" : "#000000";
  }
  get xyChartPayload(): XYChartPayload {
    return {
      ref: this.$refs.chartdiv as Optional<HTMLElement>,
      items: this.items,
      color: this.renderColor,
      xLabel: "sent",
      yLabel: "name"
    };
  }
  // ===== Watchers ===== //
  @Watch("renderColor")
  private redrawChart(): void {
    /* istanbul ignore next */
    this.chart = xyChart.drawXYChart(this.xyChartPayload);
  }
  // ===== Lifecycle Hooks ===== //
  private mounted(): void {
    /* istanbul ignore next */
    this.chart = xyChart.drawXYChart(this.xyChartPayload);
  }

  private beforeDestroy(): void {
    /* istanbul ignore next */
    if (this.chart) {
      /* istanbul ignore next */
      this.chart.dispose();
    }
  }
}
